import { VIEW_MODE } from '../../../../interface/multiCapabilityTemplate';
import React from 'react';
interface IProps {
    defaultValue?: number;
    preCls?: string;
    max?: number;
    min?: number;
    mode?: VIEW_MODE; // 编辑模式
    minTag?: string;
    maxTag?: string;
}
const CapabilityProgressScore = (props: IProps) => {
    const { preCls = 'capability-score', min = 0, max = 10, minTag = '', maxTag = '' } = props;
    const renderIndex = () => {
        const list = [];
        for (let i = min; i <= max; i++) {
            list.push(
                <li key={i} className={`${preCls}-index-info`}>
                    <div className={`${preCls}-index-item`}>{i}</div>
                </li>,
            );
        }
        return list;
    };
    const renderCircle = () => {
        const list = [];
        for (let i = min; i <= max; i++) {
            list.push(
                <li key={i} className={`${preCls}-circle-info`}>
                    <div className={`${preCls}-circle-item`} />
                </li>,
            );
        }
        return list;
    };
    return (
        <div className={preCls}>
            <div className="circle-tags left">{minTag}</div>
            <div className={`${preCls}-list`}>
                <ul className={`${preCls}-index`}>{renderIndex()}</ul>
                <div className={`${preCls}-circle-zone`}>
                    <ul className={`${preCls}-circle`}>{renderCircle()}</ul>
                </div>
            </div>
            <div className="circle-tags right">{maxTag}</div>
        </div>
    );
};
export { CapabilityProgressScore };
